<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconConnectionIndicatorMedium_24"
>
    <rect x="4" y="16" width="4" height="4" rx="1" fill="currentColor" />
    <rect x="10" y="11" width="4" height="9" rx="1" fill="currentColor" />
    <rect
        opacity=".3"
        x="16"
        y="4"
        width="4"
        height="16"
        rx="1"
        fill="currentColor"
    />
</svg>
